import { useToast } from "../components/showtoast/ToastContext.jsx";

export function parseError(error) {
  // NETWORK ERRORS (No server response)
  // if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
  //   return "Unable to connect. Please check your internet connection.";
  // }

  // console.log("Error Received: ",error)


 if (error.code === "ERR_NETWORK") {
    if (!error.request) {
      // Browser never sent request → probably no internet
      return "Unable to connect. Please check your internet connection.";
    } else {
      // Request sent but no response → server might be down
      return "Server is unreachable. May be backend is not running.";
    }
  }

  // NO RESPONSE FROM SERVER
  if (error.request && !error.response) {
    return "Server did not respond. Please try again.";
  }

  // RESPONSE RECEIVED BUT WITH ERROR STATUS
  if (error.response) {
    const status = error.response.status;

    switch (status) {
      case 400: return error.response.data.message || "Bad request.";
      case 401: return "Invalid credentials. Please login again.";
      case 403: return "You do not have permission for this action.";
      case 404: return "Requested resource not found.";
      case 409: return error.response.data.message || "Conflict detected.";
      case 422: return "Invalid or missing input.";
      case 429: return "Too many attempts. Please slow down.";
      case 500: return "Internal Server Error.";
      case 503: return "Service is temporarily unavailable.";
      default: return error.response.data.message || "Unexpected error.";
    }
  }

  // FALLBACK
  return error.message || "An unknown error occurred.";
}


// Custom Hook: Use globally
export function useApiError() {
  const { showToast } = useToast();

  return (error) => {
    const message = parseError(error);
    showToast(message, "error");
    console.error("API Error:", message, error);
    return message;
  };
}
